import { useRef } from 'react'
import { useQuery } from 'react-query'
import { parseURLParams } from '@offerzen/pinata-shame'
import { shouldRetry } from './helpers'
import { getInitialState } from '../../apiModules/initialState'

export const useFetchInitialState = ({ companyId, setInitialReduxState, searchParams }) => {
  const lastHiringTeam = useRef()
  const newHiringTeamId = parseURLParams(searchParams).current_hiring_team_id

  if (newHiringTeamId && lastHiringTeam.current !== newHiringTeamId) {
    lastHiringTeam.current = newHiringTeamId
  }

  const { data, status, error, refetch } = useQuery(
    ['initialState', companyId, lastHiringTeam.current],
    () => getInitialState(companyId, lastHiringTeam.current),
    {
      refetchOnWindowFocus: false,
      onSuccess: initialState => {
        setInitialReduxState(initialState)
      },
      retry: (failureCount, err) => shouldRetry(failureCount, err),
      select: response => {
        return response.data
      },
    },
  )
  return { data, status, error, refetch }
}
